import { Box, Button, Typography } from '@mui/material';
import { Trackable } from '@dpdgroupuk/react-event-tracker';
import { VERIFICATION } from '../../../constants/analytics';
import {
  FOUND_ACCOUNT,
  MIGRATE,
  MIGRATE_DESCRIPTION,
  MIGRATION_PROCESS_TIME,
  NEW_WEBSITE_LAUNCHED,
} from '../../../constants/strings';

function Migration({ nextStep }) {
  return (
    <Trackable
      interfaceId={VERIFICATION.INTERFACE_ID}
      loadId={VERIFICATION.LOAD}
    >
      <Box
        sx={{
          flexGrow: 1,
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: { xs: 'start', md: 'center' },
          }}
        >
          <Typography variant='h5'>{FOUND_ACCOUNT}</Typography>
          <Typography variant='body1' sx={{ mt: 2 }}>
            {NEW_WEBSITE_LAUNCHED}
          </Typography>
          <Typography variant='body1' sx={{ mt: 2 }}>
            {MIGRATE_DESCRIPTION}
          </Typography>
          <Typography variant='body1' sx={{ mt: 2 }}>
            {MIGRATION_PROCESS_TIME}
          </Typography>
          <Box
            sx={{
              mt: 5,
              display: 'flex',
              justifyContent: 'flex-start',
            }}
          >
            <Button
              type='submit'
              variant='contained'
              onClick={() => nextStep()}
            >
              {MIGRATE}
            </Button>
          </Box>
        </Box>
      </Box>
    </Trackable>
  );
}

export default Migration;
